module.exports = __webpack_public_path__ + "img/sphere_planet.42b0e809.svg";